import { defineComponent } from 'vue'

import { reactiveVueMixin } from "@skinsoft/reactive-vue"
import { FIELD_VALUE_UPDATED } from '../../events'

export const TextArea = defineComponent({
    mixins: [reactiveVueMixin],
    props: {
        type: Array,
        fieldId: {
            type: String,
        },
        value: {
            type: String,
        },
        placeholder: {
            type: String,
        },
        error: {
            type: String,
        },
        dataCy: {
            type: String,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        minRows: {
            type: Number
        },
        maxRows: {
            type: Number
        },
    },
    template: require("./text-area.html"),
    computed: {
        valueCopy: {
            get(): String {
                return this.value ?? ""
            },
            set(newValue: String) {
                this.$emit(FIELD_VALUE_UPDATED, newValue)
            },
        },
    },
})
